import { deleteField } from "../../APICalls/DeleteRequests"
import Cookies from "js-cookie"
import Popup from "../../UI/Popup";

const DeleteFieldPopup = ({
    isVisible, field, handleCloseDeleteField
}) => {
    const cutField = () => {
        const fieldObj = { id: field.id }
        deleteField(fieldObj, Cookies.get('session_key'))
            .then(data => {
                console.log(data)
            })
            .catch(error => {
                console.log(error)
            })
    }

    return (
        <Popup
            isVisible={isVisible}
            headerText="Warning"
            saveButtonText="Delete"
            handleClose={handleCloseDeleteField}
            handleSave={cutField}
            popupContent={(
                <p>You are about to delete all field data for {field.name}, click the  confirm deletion button to continue</p>
            )}
        />
    );
}

export default DeleteFieldPopup